import { SVGProps } from 'react';
const SvgArrowUpLg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 21V3M7 8l5-5 5 5"
    />
  </svg>
);
export default SvgArrowUpLg;
